import {
  ArrowDownCircleIcon,
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  ArrowUpCircleIcon,
} from '@heroicons/react/16/solid';
import { shapeMap } from './shape/shape.map';
import { Position } from '@xyflow/react';

export function getHandleStyle(
  shape: keyof typeof shapeMap,
  position: Position
): React.CSSProperties {
  if (!shapeMap[shape]) {
    console.warn(`Shape "${shape}" not found in shapeMap.`);
    return {};
  }
  if (!shapeMap[shape]?.handleOffsets) {
    return {};
  }

  const offset = shapeMap[shape]?.handleOffsets?.[position];

  const common = {
    transform: 'translate(-50%, -50%)',
  };

  switch (position) {
    case 'top':
    case 'bottom':
      return {
        ...common,
        left: '50%',
        top: `${(offset ?? (position === 'top' ? 0 : 1)) * 100}%`,
      };
    case 'left':
    case 'right':
      return {
        ...common,
        top: '50%',
        left: `${(offset ?? (position === 'left' ? 0 : 1)) * 100}%`,
      };
    default:
      return {};
  }
}

export const calculatePosition = (
  position: Position,
  nodePosition: { x: number; y: number },
  targetDims: { width: number; height: number },
  nodeDimensions: { width: number; height: number }
): { x: number; y: number } => {
  const nodeCenterX = nodePosition.x + nodeDimensions.width / 2;
  const nodeCenterY = nodePosition.y + nodeDimensions.height / 2;

  const gap = 150;
  // position in React Flow is calculated top left corner of the node not from center
  switch (position) {
    case 'left':
      return {
        x: nodePosition.x - gap - targetDims.width,
        y: nodeCenterY - targetDims.height / 2,
      };
    case 'right':
      return {
        x: nodePosition.x + nodeDimensions.width + gap,
        y: nodeCenterY - targetDims.height / 2,
      };
    case 'top':
      return {
        x: nodeCenterX - targetDims.width / 2,
        y: nodePosition.y - gap - targetDims.height,
      };
    case 'bottom':
      return {
        x: nodeCenterX - targetDims.width / 2,
        y: nodePosition.y + gap + nodeDimensions.height,
      };
    default:
      return nodePosition; // Fallback to current position
  }
};

export const popoverConfig = {
  left: {
    btnClassName: 'left-[-30px] top-1/2 -translate-y-1/2',
    popoverClassName: 'left-[-80px] top-1/2 -translate-y-1/2',
    icon: ArrowLeftCircleIcon,
  },
  right: {
    btnClassName: 'right-[-30px] top-1/2 -translate-y-1/2',
    popoverClassName: 'right-[-80px] top-1/2 -translate-y-1/2',
    icon: ArrowRightCircleIcon,
  },
  top: {
    btnClassName: 'top-[-30px] left-1/2 -translate-x-1/2',
    popoverClassName: 'top-[-50px] left-1/2 -translate-x-1/2',
    icon: ArrowUpCircleIcon,
  },
  bottom: {
    btnClassName: 'bottom-[-30px] left-1/2 -translate-x-1/2',
    popoverClassName: 'bottom-[-50px] left-1/2 -translate-x-1/2',
    icon: ArrowDownCircleIcon,
  },
};
